import React from "react";
import { Link } from "react-router-dom";

const Pagination = ({ metaData = {}, onPageChange = () => {}, loadMore = false }) => {
  const totalPages   = Math.max(1, Number(metaData.totalPages) || 1);
  const currentPage  = Math.min(Math.max(1, Number(metaData.page) || 1), totalPages);
  const pageSize     = Number(metaData.pageSize) || 0;
  const totalEntries = Number(metaData.total) || 0;

  const start = loadMore ? 1 : (currentPage - 1) * pageSize + 1;
  const end   = Math.min(currentPage * pageSize, totalEntries);

  const goToPage = (p) => {
    if (p < 1 || p > totalPages || p === currentPage) return;
    onPageChange(p);
  };

  const getPages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    const left  = Math.max(2, currentPage - 1);
    const right = Math.min(totalPages - 1, currentPage + 1);

    pages.push(1);
    if (left > 2) pages.push("ellipsis-left");
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < totalPages - 1) pages.push("ellipsis-right");
    pages.push(totalPages);
    return pages;
  };

  const pages = getPages();

  return (
    <nav
      aria-label="Pagination"
      className="d-flex align-items-center justify-content-between flex-wrap gap-2"
    >
      {/* Info: 0–0 of N when empty; otherwise start–end of N */}
      {/* <span className="pagination-info mb-2 mb-md-0">
        {end > 0 ? start : 0}–{end} of {totalEntries.toLocaleString()}
      </span> */}

      <ul className="pagination mb-0">
        {!loadMore && (
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <Link
              className="page-link"
              to="#"
              tabIndex={currentPage === 1 ? -1 : 0}
              aria-disabled={currentPage === 1}
              onClick={(e) => {
                e.preventDefault();
                goToPage(currentPage - 1);
              }}
            >
              Previous
            </Link>
          </li>
        )}

        {pages.map((p, idx) =>
          typeof p === "string" ? (
            <li key={`${p}-${idx}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={p} className={`page-item ${p === currentPage ? "active" : ""}`}>
              <Link
                className="page-link"
                to="#"
                aria-current={p === currentPage ? "page" : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  goToPage(p);
                }}
              >
                {p}
              </Link>
            </li>
          )
        )}

        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <Link
            className="page-link"
            to="#"
            tabIndex={currentPage === totalPages ? -1 : 0}
            aria-disabled={currentPage === totalPages}
            onClick={(e) => {
              e.preventDefault();
              goToPage(currentPage + 1);
            }}
          >
            Next
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
